module.exports = __webpack_public_path__ + "static/media/midas.d22df64a.png";